"use strict";
const MIN_GRAFANA_VERSION = "8.5.0";

export { MIN_GRAFANA_VERSION };
//# sourceMappingURL=constants.mjs.map
